<template>
    <ion-row v-if="instructions && instructions.length > 0" class="full-width instruction-modal-btn">
        <ion-item button detail class="full-width" data-cy="button-instruction-modal" @click="modalOpen = !modalOpen">
            <ion-label class="ion-padding-start">
                Special Instructions
                <inlineList :items="instructions?.filter((i) => i.selected)" keyName="name" />
            </ion-label>
        </ion-item>
    </ion-row>

    <modalWrapper title="Special Instructions" :open="modalOpen" @close="modalOpen = false" @dismiss="modalOpen" data-cy="instructions-modal">
        <template v-slot>
            <div class="instruction-list scrollable-content">
                <checklist :items="instructions" keyName="name" dense hideSplitOpts hideQuantity class="ion-padding list-buffer" />
            </div>
        </template>

        <template v-slot:footer>
            <ion-button color="primary" expand="full" size="large" class="force-bottom interstate-bold full-width ma-0" @click="add"> Add Instruction </ion-button>
        </template>
    </modalWrapper>
</template>

<script lang="ts">
import { defineComponent, ref, PropType } from 'vue';
import { IonItem, IonLabel, IonButton, IonRow } from '@ionic/vue';
import checklist from '@/components/menu/toppings/checklist.vue';
import { Instruction } from '@/models/menuModels';
import modalWrapper from '@/components/modals/modalWrapper.vue';
import inlineList from '@/components/inlineList.vue';

export default defineComponent({
    props: { instructions: { type: Array as PropType<Instruction[]> } },
    components: { modalWrapper, IonItem, IonLabel, IonButton, IonRow, inlineList, checklist },
    emits: ['update'],
    setup(props, { emit }) {
        const modalOpen = ref(false);
        const add = () => {
            emit('update', props.instructions?.filter((i) => i.selected) ?? []);
            modalOpen.value = false;
        };

        return { modalOpen, add };
    },
});
</script>

<style scoped>
ion-item::part(native) {
    padding-left: 0;
}
.force-bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9999999;
}
ion-modal {
    --min-height: 75vh;
    --min-width: 40vw;
}

@media screen and (max-width: 768px) {
    .scrollable-content {
        max-height: calc(75vh - 70px);
        padding-bottom: 70px;
    }
    .force-bottom {
        position: relative;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 9999999;
    }
}
</style>
